import React from 'react'

import { 
    BrowserRouter as Router, 
    Route,
    Switch,
    Redirect 
} from 'react-router-dom'

import ReactDOM from 'react-dom'

import './index.css'

import Main from './Pages/Main'
import LogIn from './Pages/LogIn'
import SignUp from './Pages/SignUp'
import Hub from './Pages/Hub'
import AppViewer from './Pages/AppViewer'
import ForgotPassword from './Pages/ForgotPassword'
import LogOutConfirm from './Pages/LogOutConfirm'
import AccountConfirm from './Pages/AccountConfirm'
import Settings from './Pages/Settings'
import ResetPassword from './Pages/ResetPassword'
import NoMatch from './Pages/NoMatch'
import Extension from './Pages/Extension'

import * as serviceWorker from './serviceWorker'

import {
    Provider 
} from 'react-redux'

import store from './Redux/Store'

import { 
    PersistGate 
} from 'redux-persist/integration/react'

import { 
    persistStore 
} from 'redux-persist'

import Amplify from 'aws-amplify'
import awsExports from './aws-exports'

Amplify.configure(awsExports)

let persistor = persistStore(store)

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <Router>
                <Switch>
                    <Route exact path='/'>
                        <Main />
                    </Route>
                    <Route exact path='/login'>
                        <LogIn />
                    </Route>
                    <Route exact path='/signup'>
                        <SignUp />
                    </Route>
                    <Route exact path='/hub'>
                        <Hub />
                    </Route>
                    <Route exact path='/appviewer/resume'>
                        <AppViewer viewType="resume" />
                    </Route>
                    <Route exact path='/forgotpassword'>
                        <ForgotPassword />
                    </Route>
                    <Route exact path='/logoutconfirmation'>
                        <LogOutConfirm />
                    </Route>
                    <Route exact path='/confirmaccount/:username/:code' component={AccountConfirm} />
                    <Route exact path='/settings'>
                        <Settings />
                    </Route>
                    <Route exact path='/resetpassword/:username/:code' component={ResetPassword} />
                    <Route exact path='/extension'>
                        <Extension />
                    </Route>
                    <Route exact path='/error'>
                        <NoMatch />
                    </Route>
                    <Redirect to="/error" />
                </Switch>
            </Router>
        </PersistGate>
    </Provider>, 
    document.getElementById('root')
)

serviceWorker.unregister()